import React from 'react';
import RequestAccessForm from './RequestAccessForm';
import { Grid } from '@material-ui/core';

const CallToAction = props => {

  return (
    <section className="cta" id="CTA">
      <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      spacing={5}
      >
        <RequestAccessForm />
      </Grid>
      <br></br>
      <br></br>
    </section>
  )
};

export default CallToAction;
